import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./SplashScreen.css";
import logo from "../assets/images/SKYBOARDGAMES_2.gif";
// import logo from '../assets/images/SKYBOARDGAMES.gif';

export default function SplashScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      localStorage.setItem("splashShown", "true");
      navigate("/login");
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="splash-container">
      <div className="splash-content d-flex flex-column p-4 align-items-center justify-content-center">
        <img src={logo} alt="Skyboard Logo (GIF)" className="splash-logo " />
        {/* <h1 className="splash-text">Skyboard</h1>
      <h1 className="splash-text-green ">Games</h1> */}
      </div>
    </div>
  );
}
